<template>
  <div class="country__list">
    <slot :setActiveClass="setActiveClass" :removeActiveClass="removeActiveClass"/>
  </div>
</template>

<script>
  import { toggleActiveClass } from '@Foundation/mixins/toggleActiveClass';

  export default {
    name: 'country-selector',

    mixins: [toggleActiveClass],

    methods: {
      removeActiveClass() {
        if (this.$el.querySelector('.active')) {
          this.$el.querySelector('.active').classList.remove('active', 'show');
        }
      },
      setActiveClass(e) {
        if (!e.target.classList.contains('active')) {
          this.removeActiveClass();
          e.target.classList.add('active', 'show');
        }
      }
    }
  };
</script>
